import { VCard } from 'vuetify/lib/components/VCard';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c(
        VCard,
        [
          _c("b-table", {
            staticClass: "text-center",
            style: { "font-size": "13px" },
            attrs: {
              responsive: "",
              hover: "",
              fields: _vm.businessTermFields,
              filter: _vm.query,
              items: _vm.items,
              "show-empty": "",
            },
            scopedSlots: _vm._u([
              {
                key: "empty",
                fn: function (scope) {
                  return [_vm._v(_vm._s(_vm.messageEmptyList))]
                },
              },
              {
                key: "cell(values)",
                fn: function (data) {
                  return [
                    _vm._l(data.value, function (value) {
                      return [
                        _c("b-badge", { attrs: { variant: "light" } }, [
                          _vm._v(_vm._s(value)),
                        ]),
                      ]
                    }),
                  ]
                },
              },
              {
                key: "cell(actions)",
                fn: function (data) {
                  return [
                    _c(
                      "b-button",
                      {
                        attrs: {
                          id: "" + data.index,
                          variant: "outline-primary",
                          size: "sm",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.openBusinessTerm(data)
                          },
                        },
                      },
                      [
                        _c("b-icon", { attrs: { icon: "eye" } }),
                        _c(
                          "b-tooltip",
                          { attrs: { target: "" + data.index } },
                          [_vm._v("Open business term")]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }